<template>
  <div class="collar">
    <el-collapse v-model="activeName" class="collapse-main-content">
      <!-- 基本信息 -->
      <el-collapse-item name="0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('glVoucher.column.info') }}
          </div>
        </template>
        <div class="collapse-content">
          <BasicInfo
            @handleChange="handleChange"
            :canEdit="canEdit"
            :previewVoucher="previewVoucher"
            ref="basicInfo"
          />
        </div>
      </el-collapse-item>
      <!-- 表格 -->
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('glVoucher.table.info') }}
          </div>
        </template>
        <div class="collapse-content">
          <CollarDetailsInfo
            :canEdit="canEdit"
            :previewVoucher="previewVoucher"
            ref="collarDetailsInfo"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList" v-if="previewVoucher != 'Y'">
      <el-button
        v-hasPermi="['2021050810535062476']"
        v-if="this.$route.name.indexOf('detail') != -1 && [null, '1', 'F'].indexOf(syncFlag) != -1"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810525113039']"
        type="primary"
        @click="save('VOUCHER_SAVE')"
        class="fixed-bottom-btn"
        :disabled="!canEdit"
        >{{ this.$t('functionBtn.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810531270405']"
        type="primary"
        :disabled="['2', 'S'].indexOf(syncFlag) != -1 || entityCode == 'AE_AP_ACCRUED'"
        @click="save('VOUCHER_DOSYNC')"
        >{{ this.$t('glVoucher.button.accountEntry') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810532315641']"
        type="primary"
        @click="save('VOUCHER_DOREVERSE')"
        :disabled="syncFlag != 'S' || reverseFlag != 'N'"
        >{{ this.$t('functionBtn.writeOff') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/generalAccounting';
  // import dataBaseAPI from '@/api/dataBase';
  import BasicInfo from './components/basicInfo';
  // import ChargeAgainsInfo from './components/chargeAgainsInfo';
  import CollarDetailsInfo from './components/collarDetailsInfo';

  export default {
    components: {
      BasicInfo,
      // ChargeAgainsInfo,
      CollarDetailsInfo,
    },
    name: 'collar',
    props: ['previewVoucher', 'voucherInfo'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        load: false,
        activeName: ['0', '1', '2'],
        canEdit: true,
        syncFlag: null, // 入账状态
        reverseFlag: null,
        entityCode: null,
      };
    },
    mounted() {
      console.log(this.previewVoucher);
      if (this.previewVoucher == 'Y') {
        this.getPreviewVoucherInfo();
      } else {
        if (this.$route.query.id) {
          this.getData();
        }
      }
      if (
        this.$route.name.indexOf('detail') != -1 ||
        this.previewVoucher == 'Y' ||
        [null, '1', 'F'].indexOf(this.syncFlag) == -1
      ) {
        this.canEdit = false;
      }
    },
    methods: {
      //凭证头部分信息变更
      handleChange(val) {
        this.$refs.collarDetailsInfo.syncHeader(val);
      },
      // 加载各模块凭证信息
      getPreviewVoucherInfo() {
        let allDetail = this.voucherInfo;
        this.setVoucherInfo(allDetail);
      },
      // 获取数据--总账凭证模块
      getData() {
        this.loading.startLoading();
        this.$axios.post(API.VOUCHER_QUERY_BY_ID, { id: this.$route.query.id }).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            let allDetail = res.data.data;
            this.setVoucherInfo(allDetail);
          }
        });
      },
      // 加载数据
      setVoucherInfo(allDetail) {
        this.syncFlag = allDetail.syncFlag;
        if ([null, '1', 'F'].indexOf(this.syncFlag) == -1) this.canEdit = false;
        this.reverseFlag = allDetail.reverseFlag;
        this.entityCode = allDetail.entityCode;
        allDetail.reverseFlag = allDetail.reverseFlag == 'Y';
        let basicInfo = this.$refs.basicInfo.baseData;
        Object.keys(basicInfo).map((item) => {
          return (basicInfo[item] = allDetail[item]);
        });
        this.$baseRequest.getPerson().then((res) => {
          basicInfo.createByName = res.find((item) => item.id == basicInfo.createBy).personName;
        });
        this.$baseRequest.getLedger(basicInfo.voucherCompanyCode).then((res) => {
          basicInfo.ledgerName = res[0].ledgerName;
        });
        this.$refs.collarDetailsInfo.tableData = allDetail.detailList;
      },
      async save(apiName) {
        // 保存
        if (apiName == 'VOUCHER_DOREVERSE' && !this.$refs.basicInfo.canRevert) {
          this.$message({ showClose: true, message: '当前单据不能冲销', type: 'error' });
          return;
        }
        let basicInfo = this.$refs.basicInfo.exportChildData();
        let detailList = await this.$refs.collarDetailsInfo.exportChildData();
        if (basicInfo && detailList) {
          let params = {
            ...basicInfo,
            detailList,
          };
          let sum = this.$refs.collarDetailsInfo.$refs.table.getTableData().footerData;
          let sumD = sum[0][7]; // 借方合计
          let sumC = sum[1][7]; // 贷方合计
          if (sumD != sumC) {
            return this.$message({
              showClose: true,
              message: this.$t('glVoucher.message.sumVerify'),
              type: 'error',
            });
          }
          params.reverseFlag = params.reverseFlag ? 'Y' : 'N';
          this.loading.startLoading();
          let res = await this.$axios.post(API[apiName], params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              if (this.$route.query.backRoute) {
                this.goBackRoute(JSON.parse(this.$route.query.backRoute));
              } else {
                this.getData();
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        }
      },
      goBack() {
        // 返回前一页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/capital/claimManage',
            name: 'claimManage',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      goBackRoute(backRoute) {
        // 返回前一页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: false,
            },
          },
          toPath: {
            path: backRoute.path,
            name: backRoute.name,
            meta: {
              keepAlive: false,
            },
            query: backRoute.query,
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
